import { useEffect, useState } from 'react';

type Props = { wpblock?: boolean; content: string; minutes?: string; alignment?: string };

const ReadingMinutes = ({ wpblock = true, content, minutes = '', alignment = '' }: Props) => {
    const [readingMins, setReadingMins] = useState('');

    useEffect(() => {
        if (!wpblock) {
            setReadingMins(
                Math.ceil(
                    content
                        ?.replaceAll(/<[^>]*>/g, ' ')
                        .trim()
                        .split(/\s+/).length / 200
                ).toString()
            );
        }
    }, []);

    const styles = wpblock
        ? 'text-sm bg-white text-black border border-gray rounded py-1 px-3'
        : '';

    return (
        <div className={`flex ${alignment}`}>
            <div className={styles}>
                {minutes !== '' ? minutes : readingMins !== 'NaN' ? readingMins : '0'} min read
            </div>
        </div>
    );
};

export default ReadingMinutes;
